"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
const change_case_1 = require("change-case");
const ContentKeyModal_1 = require("../ContentKeyModal");
const react_use_1 = require("react-use");
const react_if_1 = require("react-if");
const ButtonContainer_1 = require("../ButtonContainer");
exports.EmailCanvasBlockContentKeyButton = ({ contentFieldKeyCanBeChanged, contentFieldKey, contentCanBeChanged, type, }) => {
    const [isOpen, toggle] = react_use_1.useToggle(false);
    const prettyContentFieldKey = react_1.useMemo(() => {
        if (type === 'group' || type === 'repeater') {
            return '';
        }
        return change_case_1.sentenceCase(contentFieldKey);
    }, [contentFieldKey]);
    if (!contentFieldKey) {
        return null;
    }
    const disabled = !contentCanBeChanged || !contentFieldKeyCanBeChanged;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_if_1.When, { condition: isOpen },
            react_1.default.createElement(ContentKeyModal_1.EmailCanvasBlockContentKeyModal, { isOpen: isOpen, toggle: toggle })),
        react_1.default.createElement(ButtonContainer_1.ButtonContainer, null,
            react_1.default.createElement(react_2.OsmosysButtonBlockToolbar, { tooltip: disabled ? 'Using imported content' : 'Change content source', osysIcon: "mappedContent", osysName: "EmailCanvasBlockContentKeyButton", disabled: disabled, onClick: () => {
                    if (disabled) {
                        return;
                    }
                    toggle();
                } }, prettyContentFieldKey))));
};
//# sourceMappingURL=ContentKeyButton.js.map